import { LogLevel } from '@angular/compiler-cli';
import { Injectable } from '@angular/core';
import { ConfigService, LoggingLevel } from './config-service.service';

//https://medium.com/@dneimke/configurable-logging-in-angular-projects-30dd5d999db6
@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  private _level: LoggingLevel = LoggingLevel.Warnings;

  constructor(config: ConfigService) {

    if (config.loggingLevel) {

      this._level = config.loggingLevel;

    }

  }

  //log(message: any, level = LoggingLevel.Warnings, ...optionalParams: any[]) {
  log(message: any, level: LoggingLevel, ...optionalParams: any[]) {


    //Based on our config we May NOT log errors.
    //IE if we passed a warning msg, and we set in config to log errors - we will not log
    let shouldLog = this.shouldLog(level);

    if (shouldLog) {

      switch (level) {

        case LoggingLevel.Errors:
          console.error(message, optionalParams);
          break;

        case LoggingLevel.Warnings:
          console.warn(message, optionalParams);
          break;

        case LoggingLevel.Info:
          console.info(message, optionalParams);
          break;

        default:
          console.debug(message, optionalParams);

      }
    }

  }

  shouldLog(level: LoggingLevel) {

    if (this._level === LoggingLevel.None) {

      return false;

    } else if (this._level === LoggingLevel.Errors) { //show ONLY ERRORS if config is Errors

      return level === LoggingLevel.Errors;

    } else if (this._level === LoggingLevel.Warnings) { //show Warnings OR Errors if config is Warnings

      return level === LoggingLevel.Errors || level === LoggingLevel.Warnings;

    } else if (this._level === LoggingLevel.Info) { //show ALL if config is Info

      return level === LoggingLevel.Errors || level === LoggingLevel.Warnings || level === LoggingLevel.Info;

    } else {

      return true;

    }
  }

  //https://medium.com/@dneimke/configurable-logging-in-angular-projects-30dd5d999db6
  //From here you could consider extending the logger to send messages to a centralized telemetry store such as
  //Application Insights or integrating with the Angular ErrorHandler.
  logError(message: any, ...optionalParams: any[]) {
    this.log(message, LoggingLevel.Errors, optionalParams);
  }

  logWarning(message: any, ...optionalParams: any[]) {
    this.log(message, LoggingLevel.Warnings, optionalParams);
  }

  logInfo(message: any, ...optionalParams: any[]) {
    this.log(message, LoggingLevel.Info, optionalParams);
  }

  logVerbose(message: any, ...optionalParams: any[]) {
    this.log(message, LoggingLevel.Verbose, optionalParams);
  }

}
